module.exports = __webpack_public_path__ + "static/media/assembly_C1.3013917f.png";